<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 px-2 py-6">

        <!-- MAIL ROW 1 : META -->
        <div class="flex w-full">
            <!-- <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white" :src="mail.img" size="40px"></vs-avatar> -->
            <!-- <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-white" src="@/assets/images/portrait/small/avatar-s-11.jpg"  size="40px"></vs-avatar> -->
            <img key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40" class="sender__avatar flex-shrink-0 mr-3 border-2 border-white rounded-full shadow-md cursor-pointer block" />

            <div class="flex w-full justify-between items-start ">
                <div class="mail__details">
                    <h5 class="mb-1" :class="{'font-semibold': alarm.unread}">{{ alarm.name }}</h5>
                    <!-- <h5 class="mb-1" :class="{'font-semibold': true}">{{ alarm.name }}</h5> -->
                    <span :class="{'font-semibold': alarm.unread}">{{ alarm.title }}</span>
                </div>

                <div class="mail-item__meta flex items-center">
                    <div class="email__labels hidden sm:flex items-center">
                        <div class="h-2 w-2 rounded-full mr-2" :class="'bg-' + labelColor(alarm)"></div>
                    </div>
                    <span>{{ alarm.create_time | onlydate }}</span>
                </div>
            </div>
        </div>
        <!-- /MAIL ROW 1 -->

        <!-- MAIL ROW 2 : MSG & ACTIONS -->
        <div class="flex w-full">
            <div class="flex items-center ml-1">
                <!-- <vs-checkbox v-model="isSelectedMail" @click.stop class="vs-checkbox-small ml-0 mr-1"></vs-checkbox> -->
                <!-- <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning fill-current stroke-current': mail.isStarred}, 'w-5', 'h-5']" @click.stop="toggleIsStarred"></feather-icon> -->
            </div>
            <!-- <div class="mail__message truncate ml-3">
                <span>{{ alarm.detail | filter_tags }}</span>
            </div> -->
        </div>
        <!-- /MAIL ROW 2 -->
    </div>
</template>

<script>
export default {
  props: ['alarm'],
  selected: [],
  data() {
    return {
      photoURL:require("@/assets/images/portrait/small/" + this.alarm['sender_photo_url'])
    }
  },
  computed: {
    labelColor() {
      return (label) => {
        const tags = this.$store.state.alarm.alarmTag
        var findTag = tags.find((tag) => { return tag.value == label.tag })
        if(findTag) {
          return findTag.color
        } else{
          return 'dark'
        }
      }
    },
  },
}

</script>
